/*
 * File: d:\projects\AutoFiFront\src\Content\SVG\CategorySVG\Sedan.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Monday March 13th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday March 13th 2023 2:17:13 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */
import { SVGProps } from 'Content/SVG/SVGProps';

function Sedan(props: SVGProps) {
    return(
        <svg id="Calque_1" fill={props.fill} stroke={props.stroke} strokeWidth={props.strokeWidth} data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080">
            <path d="M239.32,478.78c37.17-3.06,149.06-6.23,149.06-6.23,123.95-64.24,160.54-64.85,209.91-64.32,31.51,.34,102.81,2.8,102.81,2.8,119.63,0,234.69,79.6,234.69,79.6,.9,.61,1.72,1.26,2.5,1.93,.25,.21,.47,.44,.71,.66,.51,.47,1,.96,1.46,1.46,.24,.26,.48,.53,.7,.8,.42,.5,.81,1.01,1.18,1.54,.19,.27,.39,.53,.57,.8,.46,.71,.89,1.44,1.27,2.2,.13,.25,.23,.5,.35,.75,.3,.65,.59,1.32,.83,1.99,.14,.38,.26,.78,.38,1.17,.15,.5,.3,1,.43,1.51,.11,.44,.21,.89,.3,1.35,.09,.48,.17,.96,.24,1.44,.07,.48,.15,.97,.2,1.46,.05,.45,.07,.92,.09,1.38,.07,1.05,.09,2.11,.07,3.19,0,.35,0,.7-.02,1.06-.03,.66-.08,1.32-.14,1.99-.03,.35-.06,.7-.1,1.05-.08,.7-.16,1.39-.27,2.1-.04,.29-.1,.59-.14,.89-.43,2.59-1.03,5.24-1.81,7.94-.03,.09-.05,.18-.07,.26h0c-3.15,10.89-8.84,22.52-15.15,33.58h7.45c3.44,0,6.23,1.13,6.23,4.57l-6.23,36.99c0,3.44-2.79,5.83-6.23,5.83h-33.28c-15.22,14.63-29.57,11.62-29.57,11.62,0,0-13.13,.04-35.84,.11-12.62,25.79-39.04,43.59-69.69,43.59s-55.61-16.78-68.64-41.38H344.72c-13.02,24.6-38.85,41.38-68.62,41.38s-56.12-17.14-69.01-42.15c-10.39,0-20.12,.01-29.04,.01-29.61,0-67.13-35.84-67.13-85.95,0-34.61,84.27-55.31,128.41-58.95Z"/>
        </svg>
    );
}

export default Sedan;
